import { GeoCodeConstants } from '../constants';

export function geoCodeReducer(state = {}, action) {
    switch (action.type) {
        case GeoCodeConstants.GET_GEOCODE_REQUEST:
            return {
                loading: true
            };
        case GeoCodeConstants.GET_GEOCODE_SUCCESS:
            return {
                items: action.geoCode
            };
        case GeoCodeConstants.GET_GEOCODE_FAILURE:
            return {
                error: action.error
            };
        default:
            return state
    }
}